<template>
    <section class="flex md:flex-col">
        <div>
            <AdminDashboardNav/>
        </div>
        <section class="font-poppins w-screen md:p-2 pl-10 pr-10">
            <section class="mt-6">
                <div class=" flex justify-between md:flex-col-reverse">
                    <div>
                        <GetDate/>
                        <p class="text-blue-700 font-bold text-2xl md:text-xl">MANAGE DSOS</p>
                    </div>

                    <div class=" mr-10">
                        <Notification/>
                    </div>
                </div>
            </section>

            

            <section>
                

                <div>
                    <!-- <PendingDsos/> -->
                    <DsoList/>
                </div>
            </section>
        </section>
    </section>
</template>

<script>
import axios from 'axios';
import AdminDashboardNav from '../AdminDashboardNav.vue';
// import PendingDsos from './PendingDsos.vue'; 
import DsoList from './DsoList.vue';
import GetDate from '../GetDate.vue';
import Notification from '../Notification.vue';
import {baseUrl} from '../../../Config';
const url = baseUrl;
export default {
    components : {
        AdminDashboardNav,
        // PendingDsos,
        GetDate,
        Notification,
        DsoList
    },
    data() {
        return {
            dsos : [],
            token: localStorage.getItem("token")
        }
    },
 
    mounted() {
        this.get_Dsos();
        this.networkError();
    },

    methods: {
        get_Dsos() {
            axios({
                method: 'GET',
                url: `${url}/v1/web/users?sortBy=role&limit=20&page=1`,
                headers: {
                    'Content-type': 'application/json',
                    authorization: `Bearer ${this.token}`,
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                }
            })
             .then((response) => {
                 this.dsos = response.data.data.results
             })
             .catch ((error) => {
                 console.log(error)
             })   

        },

        networkError() {
            if(!navigator.onLine) {
                this.$router.push('/network-error')
            } 
        }

    }
}
</script>